interface PageMetaProps {
  title: string;
  description: string;
  keywords: string;
}

/**
 * 使用 React 19 内置的文档元数据能力，
 * 渲染的 title / meta 会被自动提升到 <head>。
 */
export default function PageMeta({ title, description, keywords }: PageMetaProps) {
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
    </>
  );
}